import { getRequest, type IValidatedResponse } from '../../httpClient';
import type { IGetProgressForecastV1Request } from './get-progress-forecast-v1-request';
import type { IGetProgressForecastV1Response } from './get-progress-forecast-v1-response';
import { getProgressForecastV1ResponseSchema } from './get-progress-forecast-v1-response';

export async function getProgressForecastV1Api(
  params?: IGetProgressForecastV1Request,
): Promise<IValidatedResponse<IGetProgressForecastV1Response>> {
  const query = new URLSearchParams();
  if (params?.timezoneOffsetMinutes !== undefined) {
    query.set('timezoneOffsetMinutes', String(params.timezoneOffsetMinutes));
  }

  const qs = query.toString();

  return getRequest<IGetProgressForecastV1Response>({
    path: qs ? `/progress/forecast/v1?${qs}` : '/progress/forecast/v1',
    schema: getProgressForecastV1ResponseSchema,
  });
}
